import BaseApi from "./baseAPI";

class AssignmentAPI extends BaseApi{
  get entity() {
    return {
      route: `${this.getCourseId()}/assignments`,
      name: 'الواجب'
    }
  }

  getAssignmentCorrection(id){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}/${id}/correction`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  correctAssignment(id, data){
    return new Promise((resolve, reject) => {
      return this.request.put(`${this.entity.route}/${id}/correction`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  answer(assignment_id, data, config = null) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${assignment_id}/answer`, data, config)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  confirm(id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/confirm`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new AssignmentAPI()
